import React from "react";
import { useHistory } from "react-router-dom";

/**
 * TrendingRoleCard — "Product Manager is the most-posted role this week"
 *
 * Shows the most-posted role with a count. Browse Jobs CTA.
 *
 * When the user clicks "Browse {role}", they're navigated to /home?search=ROLE_TITLE
 * which triggers a job search for that role on the Home page.
 *
 * Props:
 *   card — feed card object with metadata containing:
 *     role_title, posting_count
 */
const TrendingRoleCard = ({ card }) => {
  const history = useHistory();
  const meta = card.metadata || {};

  const handleBrowse = () => {
    const roleTitle = meta.role_title || "";
    if (roleTitle) {
      // Navigate to home with search query — Home page will trigger searchJobAction
      history.push(`/home?search=${encodeURIComponent(roleTitle)}`);
    } else {
      history.push("/home");
    }
  };

  return (
    <div style={styles.card}>
      <div style={styles.cardBody}>
        <div style={styles.headerRow}>
          <div style={styles.iconWrap}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#3a6ed4" strokeWidth="2">
              <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
              <polyline points="17 6 23 6 23 12" />
            </svg>
          </div>
          <span style={styles.timestamp}>{formatTime(card.created_at)}</span>
        </div>

        <h6 style={styles.title}>
          {meta.role_title || "This role"} is trending this week
        </h6>
        <p style={styles.detail}>
          {meta.posting_count || 0} new postings — the most-posted role on Workbrook this week
        </p>

        <button style={styles.browseBtn} onClick={handleBrowse}>
          Browse {meta.role_title || "Jobs"}
        </button>
      </div>
    </div>
  );
};

function formatTime(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const now = new Date();
  const diffHrs = (now - date) / (1000 * 60 * 60);
  if (diffHrs < 1) return "Just now";
  if (diffHrs < 24) return `${Math.floor(diffHrs)}h ago`;
  const diffDays = Math.floor(diffHrs / 24);
  if (diffDays === 1) return "1d ago";
  return `${diffDays}d ago`;
}

const styles = {
  card: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    marginBottom: "16px",
  },
  cardBody: {
    padding: "20px",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
  },
  iconWrap: {
    width: "40px",
    height: "40px",
    borderRadius: "20px",
    backgroundColor: "#ebf6fd",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  timestamp: {
    fontSize: "12px",
    color: "#94a3b8",
  },
  title: {
    fontSize: "16px",
    fontWeight: "700",
    color: "#0f172a",
    margin: "0 0 6px 0",
  },
  detail: {
    fontSize: "14px",
    color: "#64748b",
    margin: "0 0 16px 0",
  },
  browseBtn: {
    padding: "10px 24px",
    backgroundColor: "#fff",
    color: "#3a6ed4",
    border: "1px solid #3a6ed4",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
};

export default TrendingRoleCard;
